import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  get_branch_dropDown_data,
  get_employee_data,
} from "../../services/employeeApi";
import {
  get_ekyc_lists,
  get_unassigned_ekyc,
  RegisterEkycAssignment,
} from "../../services/projectApi";
import { toast } from "react-toastify";
import { validateForm } from "../../middleware/validateProjectForm";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
const RegisterEkycAssignmentForm = ({ parentID, onSubmitButton }) => {
  const { t } = useTranslation();
  let history = useHistory();
  const user = GetUserInfo();
  const user_branch = user?.employee?.branch_id;
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const queryClient = useQueryClient();
  const registrationMutation = useMutation(async (newData) => {
    await RegisterEkycAssignment(newData);
    queryClient.invalidateQueries("getbranchempekycAssignment");
  });

  const [formData, setFormData] = useState({
    device_id: "",
    employee_id: "",
    username: "",
    assigned_from: "",
    assigned_to: null,
    status: "ASSIGNED",
    remark: "Assigned for project X",
    created_by: "",
    updated_by: "",
  });

  const { data, isLoading, isError, error } = useQuery(
    ["task-assignment"],
    async () => {
      try {
        const branchData = await get_branch_dropDown_data();
        const taskData = await get_ekyc_lists(user_branch);
        const unassignedDevice = await get_unassigned_ekyc(user_branch);
        const employeeData = await get_employee_data();
        return { branchData, taskData, employeeData, unassignedDevice };
      } catch (error) {
        throw new Error(`Error fetching data: ${error.message}`);
      }
    }
  );

  const filteredEmployeeData = useMemo(() => {
    const employeeData = data?.employeeData || [];

    if (!Array.isArray(employeeData)) return [];

    if (user.accessRole === "administrator") return employeeData;

    if (user.accessRole === "manager") {
      return employeeData.filter(
        (emp) => emp.branch_id === user?.employee?.branch_id
      );
    }

    return employeeData.filter((emp) => emp.id === user?.employee?.id);
  }, [data]);
  // const filteredBranchData = useMemo(() => {
  //   const branchData = data?.branchData || [];

  //   if (!Array.isArray(branchData)) return [];

  //   if (user.accessRole === "administrator") return branchData;

  //   if (user.accessRole === "manager") {
  //     return branchData.filter((br) => br.id === user?.employee?.branch_id);
  //   }
  //   return branchData.filter((br) => br.id === user?.employee?.branch_id);
  // }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const { taskData } = data;
  const { unassignedDevice } = data;
  const handleRegistration = async (assignmentData) => {
    try {
      setIsSubmitting(true);
      await registrationMutation.mutateAsync(assignmentData);
      toast.success("Registration successful", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
      history.push(`/branch-employee-assignment`);
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["device_id", "employee_id", "username"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    handleRegistration(formData);

    // const errors = validateForm(formData);
    // if (Object.keys(errors).length === 0) {
    //   handleRegistration(formData);
    // } else {
    //   setValidationErrors(errors);
    // }
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="col-md-12 mb-3">
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("device_name")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.device_id}
            onChange={(e) => handleInputChange(e, "device_id")}
          >
            <option value="" hidden disabled>
              Select Device
            </option>
            {unassignedDevice?.map((data) => (
              <option key={data?.id} value={data?.id}>
                {`${data?.device_name} - SN: ${data?.serial_number}`}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("employee")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.employee_id}
            onChange={(e) => handleInputChange(e, "employee_id")}
          >
            <option value="" hidden disabled>
              Select Employee
            </option>
            {filteredEmployeeData?.map((data) => (
              <option key={data?.id} value={data?.id}>
                {data?.first_name} {data?.father_name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("username")}
          </Form.Label>
          <Form.Control
            type="text"
            id="username"
            value={formData.username}
            onChange={(e) => handleInputChange(e, "username")}
            required
            placeholder="Enter username"
          ></Form.Control>
        </div>
        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("description")}
          </Form.Label>
          <Form.Control
            type="date"
            id="assigned_from"
            value={formData.assigned_from}
            onChange={(e) => handleInputChange(e, "assigned_from")}
            required
            placeholder="Enter assigned date"
          ></Form.Control>

          {formerror ? (
            <p className="text-danger">
              Looks like something’s missing! Please make sure to complete all
              required fields before submitting your registration.
            </p>
          ) : (
            ""
          )}
        </div>
        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="bt btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="bt btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("register")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default RegisterEkycAssignmentForm;
